import {
  invalidValidationError,
  missingAllData,
  sspValidationError,
} from 'mocks/server/data/draftErrors';
import {
  baseEntityWithEmptyFields,
  baseEntityWithNullFields,
} from 'mocks/server/data/generation/generateBaseEntity';
import { baseLinkedAsset } from 'mocks/server/data/linkedAssets';
import { IDraftLinkedAsset } from 'types/detailsEntityType';
import { EntityType } from 'types/entityType';
import { DraftStatus, LiveStatus } from 'utils/statuses';

export const draftLinkedAssetWithNullFields: IDraftLinkedAsset = {
  ...baseEntityWithNullFields('nullLA', EntityType.LINKED_ASSET),
  linkedAssetFrames: null,
  status: DraftStatus.INCOMPLETE,
  intendedLiveStatus: LiveStatus.ARCHIVED,
  draftErrors: [missingAllData],
};

export const draftLinkedAssetWithEmptyFields: IDraftLinkedAsset = {
  ...baseEntityWithEmptyFields('emptyLA', EntityType.LINKED_ASSET),
  linkedAssetFrames: [],
  status: DraftStatus.INCOMPLETE,
  intendedLiveStatus: LiveStatus.ARCHIVED,
  draftErrors: [missingAllData],
};

export const draftLinkedAssetWithNullFieldsComparedToLive: IDraftLinkedAsset = {
  ...baseEntityWithNullFields('nullLAvsLive', EntityType.LINKED_ASSET),
  linkedAssetFrames: null,
  status: DraftStatus.INCOMPLETE,
  intendedLiveStatus: LiveStatus.ARCHIVED,
  draftErrors: [missingAllData],
};

export const draftLinkedAssetWithEmptyFieldsComparedToLive: IDraftLinkedAsset = {
  ...baseEntityWithEmptyFields('emptyLAvsLive', EntityType.LINKED_ASSET),
  linkedAssetFrames: [],
  status: DraftStatus.INCOMPLETE,
  intendedLiveStatus: LiveStatus.ARCHIVED,
  draftErrors: [missingAllData],
};

export const allNewFieldsDraftLinkedAsset: IDraftLinkedAsset = {
  ...baseLinkedAsset(),
  spaceId: 'NewLA',
  status: DraftStatus.READY,
  intendedLiveStatus: LiveStatus.INACTIVE,
};

export const allUpdatedFieldsDraftLinkedAsset: IDraftLinkedAsset = {
  ...baseLinkedAsset(),
  spaceId: 'UpdatedLA',
  status: DraftStatus.READY,
  intendedLiveStatus: LiveStatus.ACTIVE,
  auctionToSpotTimeMinutes: 120,
  operatingHours: {
    MONDAY: ['06:00 - 21:29'],
    TUESDAY: ['06:00 - 21:29'],
    WEDNESDAY: ['06:00 - 21:29'],
    THURSDAY: ['06:00 - 21:29'],
    FRIDAY: ['06:00 - 21:29'],
    SATURDAY: ['06:00 - 21:29'],
    SUNDAY: ['06:00 - 21:29'],
  },
};

export const syncingDraftLinkedAsset: IDraftLinkedAsset = {
  ...baseLinkedAsset(),
  spaceId: 'syncingLA',
  status: DraftStatus.SYNCING,
  intendedLiveStatus: LiveStatus.ACTIVE,
};

export const errorDraftLinkedAsset: IDraftLinkedAsset = {
  ...baseLinkedAsset(),
  spaceId: 'errorLA',
  status: DraftStatus.ERROR,
  intendedLiveStatus: LiveStatus.ACTIVE,
  draftErrors: [sspValidationError],
};

export const invalidDraftLinkedAsset: IDraftLinkedAsset = {
  ...baseLinkedAsset(),
  spaceId: 'invalidLA',
  status: DraftStatus.INVALID,
  intendedLiveStatus: LiveStatus.ACTIVE,
  draftErrors: [invalidValidationError],
};

export const draftLinkedAsset: IDraftLinkedAsset = {
  ...baseLinkedAsset(),
  spaceId: '22222222222',
  status: DraftStatus.READY,
  intendedLiveStatus: LiveStatus.ACTIVE,
};

export const draftLAWithLive: IDraftLinkedAsset = {
  ...baseLinkedAsset(),
  spaceId: 'LAWithDraft',
  status: DraftStatus.READY,
  intendedLiveStatus: LiveStatus.INACTIVE,
};

export const generateDraftLinkedAssets = (): IDraftLinkedAsset[] => {
  return [
    draftLinkedAssetWithNullFields,
    draftLinkedAssetWithEmptyFields,
    draftLinkedAssetWithNullFieldsComparedToLive,
    draftLinkedAssetWithEmptyFieldsComparedToLive,
    allNewFieldsDraftLinkedAsset,
    allUpdatedFieldsDraftLinkedAsset,
    syncingDraftLinkedAsset,
    errorDraftLinkedAsset,
    invalidDraftLinkedAsset,
    draftLinkedAsset,
    draftLAWithLive,
  ];
};
